import {
    getServerTexts as getTexts,
    initTexts,
    texts as localization
} from '../../../../Localization/texts';

initTexts;

export const entity = 'UI_NEWBPM';

export const en = {
    search_list_placeholder: 'Search...',
    new_status_dialog_title: 'Create New Status',
    edit_status_dialog_title: 'Properties of the "[X]" status',
    status_dialog_btn_save: 'Save',
    status_dialog_btn_cancel: 'Cancel',
    status_dialog_help: 'Help',

    statuses_dialog_help: 'Help',
    statuses_dialog_title: 'Deleted Statuses',
    statuses_list_dialog_btn_confirm: 'Ok',
    statuses_list_dialog_btn_back: 'Back',
    hidden_statuses_label: 'Deleted statuses',
    status_dialog_rules_title: 'Status Rules for',
    status_open_rule_title: 'Status Rules for',
    path_open_rule_title: 'Rules for Changing from',
    status_dialog_rules_help:
        'Use rules to shorten and automate your workflow.\n' +
        'Here you can view a list of your existing rules.\n' +
        'Find a rule using filters, or use the search box.\n' +
        'Edit, duplicate, or delete, simply and easily.\n' +
        'Click the New button to start creating rules.',
    number_input_label: 'Set number of',
    doc_reaches_status: 'The document reaches this status',
    doc_remains_status: 'The document remains in this status longer than:',
    date_in_the: 'Date in the',
    ago_label: 'ago',
    permission_rule_upd_error: 'This rule was created by another user, so you cannot edit it.',
    warning_label: 'Note:',
    status_rule_help:
        'Here you can create new or edit existing BPM rules. On the left “When” section, set the rule and the condition for the rule. On the right “Then” section, set the action that will take place if conditions are met.',
    from_status_label: 'from',
    to_status_label: 'to',
    save_label: 'Save',
    toolbar_active_label: 'Active Paths:',
    toolbar_active_tooltip:
        'Turn on Active Paths to activate paths and rules between different statuses.',
    add_path: 'Create path',
    set_rules: 'Set rules',
    set_properties: 'Set properties',
    set_color: 'Set color',
    delete_label: 'Delete',
    options_label: 'Options',
    copy_label: 'Copy',
    paste_label: 'Paste',
    report_label: 'Create report',
    bpm_screen_title: 'BPM Flow Chart - [X]',
    status_name_label: 'Status Name',
    status_ename_label: 'Status Name in Second Language',
    name_input_placeholder: 'Enter a name…',
    bpm_loader_title: 'BPM',
    add_tooltip: 'Add tooltip',
    rename_label: 'Rename',
    permitted_status: 'Permitted initial status',
    menu_set_props: 'Set properties',
    menu_set_rules: 'Set rules',
    help_title: 'Help',
    BPM_title: 'BPM Flow Chart',
    empty_state_bpm_rule_title: 'BPM rules will appear here.',
    empty_state_bpm_rule_text: 'Click the New button to create a rule.',
    create_status_help_text:
        'Here you can define a new status. Enter the status name and if necessary, the name of the status in a second language. \n Choose the relevant properties for the status. \n For more information on status properties, see the field help for each property in the relevant Statuses form.',
    properties_help_text:
        'Here you can define properties for the status. \n For more information on status properties, see the field help for each property in the relevant Statuses forms.',
    BPM_help_text: `Use Business Process Management (BPM) flow charts to control and monitor the progress of system processes. This visual representation reflects the steps and sequences of your organization’s workflow, optimizing the efficiency of the process.

Statuses appear as shapes, and paths as arrows. You can define statuses and link them together using paths, creating a sequence.

For example, a document starts in an initial status like “Draft,” then may move to a status like “In Progress”, before being “Approved” or “Closed.” Each major document in a defined work process has its own flow chart.

Use the icons on the bottom of the form or right-click the status or path, for options such as:

creating a new path

defining rules and properties

color-coding

adding tooltips

Set properties for statuses allows you to define attributes of the status, such as whether a document:

can be updated

will be included in your To Do List

is cancelled

is paid for

Define rules for either statuses or paths to trigger a variety of automatic actions when certain conditions are met, such as sending automatic emails, text messages, or push messages (for Priority Mobile). Other options include re-assigning the document or opening a task.

One of the most frequently used rules, for example, is a rule that determines the user to which the document is assigned at each stage of the process. `,
    close: 'Close',
    ok_btn_text: 'Ok',
    allow_status_change_for: 'For',
    push_notification_action: 'Send notification',
    push_notification_action_tooltip: 'to Priority Mobile',
    assign_to_action: 'Assign to',
    allow_status_change_action: 'Allow status change',
    save_changes_msg: 'We saved your changes.'
};

export const he = {
    search_list_placeholder: 'חיפוש...',
    new_status_dialog_title: 'יצירת סטטוס חדש',
    edit_status_dialog_title: 'Properties of the "[X]" status',
    status_dialog_btn_save: 'שמירה',
    status_dialog_btn_cancel: 'ביטול',
    status_dialog_help: 'עֶזרָה',
    statuses_dialog_help: 'Help',
    statuses_dialog_title: 'סטטוסים שנמחקו',
    statuses_list_dialog_btn_confirm: 'Ok',
    statuses_list_dialog_btn_back: 'Back',
    hidden_statuses_label: 'Hidden statuses',
    status_dialog_rules_title: 'חוקים לסטטוס',
    status_open_rule_title: 'חוקים לסטטוס',
    path_open_rule_title: 'חוקים למעבר מסטטוס',
    status_dialog_rules_help:
        'כאן תוכלו לצפות ברשימת החוקים ולנהל אותם.\n' +
        'אתרו חוק בקלות באמצעות חיפוש חופשי או סינון לפי מגוון פרמטרים.\n' +
        'תוכלו לערוך, לשכפל או למחוק חוקים בקלות.\n' +
        'לחצו על הכפתור "חדש" כדי ליצור את החוק.',
    number_input_label: 'קבעו מספר',

    doc_reaches_status: 'התעודה עוברת לסטטוס זה',
    doc_remains_status: 'התעודה נמצאת בסטטוס זה יותר מ',
    date_in_the: 'התאריך שבשדה',
    ago_label: '',
    permission_rule_upd_error: 'משתמש אחר יצר את החוק הזה ולכן לא תוכלו לערוך אותו.',
    warning_label: 'כדאי לשים לב ',
    status_rule_help:
        'הגדירו פעולות אוטומטיות שיתבצעו בהתאם לתנאים שתקבעו מראש. בצד ימין "אם" מגדירים את תנאי החוק. בצד שמאל "אז" מגדירים את הפעולה שתתבצע כשמתקיימים תנאי החוק (למשל, הצגת הודעת שגיאה או אזהרה, שליחת אימייל או הודעת פוש למובייל ועוד). לדוגמה, נציג הודעת אזהרה כשבהזמנת לקוח רושמים בשדה "אחוז הנחה" מספר הגדול מהמספר שתגדירו.',
    from_status_label: 'from',
    to_status_label: 'לסטטוס Y',
    save_label: 'שמירה',
    toolbar_active_label: 'מעברים פעילים',
    toolbar_active_tooltip: 'הפעלת מעברים בין הסטטוסים השונים בהתאם לחוקים שהוגדרו.',
    add_path: 'יצירת קישור',
    set_rules: 'הגדרת חוקים',
    set_properties: 'הגדרת מאפיינים',
    set_color: 'הגדרת צבע',
    delete_label: 'מחיקה',
    options_label: 'Options',
    copy_label: 'העתקה',
    paste_label: 'הדבקה',
    report_label: 'הפקת דו”ח',
    bpm_screen_title: 'ניהול תהליך - [X]',
    status_name_label: 'שם הסטטוס',
    status_ename_label: 'שם הסטטוס בשפה שנייה',
    name_input_placeholder: 'רשמו שם…',
    bpm_loader_title: 'ניהול תהליך',
    add_tooltip: 'הוספת טול-טיפ',
    rename_label: 'שינוי שם',
    permitted_status: 'סטטוס התחלתי',
    menu_set_props: 'הגדרת מאפיינים',
    menu_set_rules: 'הגדרת חוקים',
    help_title: 'עזרה',
    BPM_title: 'ניהול תהליך',
    empty_state_bpm_rule_title: 'החוקים שלך יופיעו כאן.',
    empty_state_bpm_rule_text: 'לחצו על הכפתור "חדש" כדי ליצור חוק.',
    create_status_help_text:
        'כאן תוכלו לערוך את המאפיינים של הסטטוס. סמנו את המאפיינים הרלוונטיים או הסירו סימון במידת הצורך.\n' +
        'תוכלו למצוא הסבר על המאפיינים בעזרה המקוונת במסכי הסטטוס הרלוונטיים.',
    properties_help_text:
        'כאן תוכלו להוסיף סטטוס חדש לתהליך. רשמו שם בעברית בשדה “שם הסטטוס” ואת שם הסטטוס בשפה שנייה במידת הצורך.\n' +
        'לאחר מכן, סמנו את המאפיינים המתאימים לסטטוס.\n' +
        'תוכלו למצוא הסבר על המאפיינים בעזרה המקוונת במסכי הסטטוס.',
    BPM_help_text: `בתרשים הגרפי ל ניהול תהליך (BPM) תוכלו לבנות תרשים זרימה להגדרת תהליכי עבודה אופטימליים בחברתכם,

כל שלב בתהליך הוא סטטוס של תעודה ומיוצג ע"י צורה (מלבן או אליפסה) בתרשים. את הסטטוסים השונים מחברים לרצף בתהליך באמצעות קישורים (חצים).

לדוגמה, הסטטוס ההתחלתי של תעודה מסויימת הוא "טיוטה". סטטוס זה מקושר ומוביל לסטטוס הבא – "בתהליך" וסטטוס זה מקושר ומוביל לסטטוס "סופי".

באמצעות הפעולות בתחתית המסך, או בלחיצה על הקליק הימני של העכבר על סטטוס או קישור, תוכלו:

ליצור קישור חדש

להגדיר חוקים עסקיים ומאפיינים

להגדיר צבעים

להוסיף טול-טיפ

הגדירו מאפיינים לסטטוסים הקובעים את התכונות של כל סטטוס כמו "תעודה מבוטלת" ו"תעודה שולמה" ומה אפשר לבצע בתעודה שנמצאת בסטטוס זה. למשל, אפשרות לעדכן תעודה או הוספת התעודה לנושאים לביצוע.

הגדירו חוקים לסטטוסים או קישורים כדי להפעיל מנגנונים אוטומטיים בהתאם לתנאים שתגדירו כמו למשל:

שליחת אימייל אוטומטית

שליחת הודעות טקסט

הוספת הודעות פוש (עבור פריוריטי מובייל).

העברת התעודה לטיפול משתמש אחר

פתיחת משימה

תוכלו להגדיר את החוק למשתמש אחד או לכמה משתמש

חוק שימושי יכול להיות חוק הקובע איזה משתמש יקבל את המסמך לטיפול, בכל שלב בתהליך. `,
    close: 'סגירה',
    ok_btn_text: 'אישור',
    allow_status_change_for: 'עבור',
    push_notification_action: 'הודעת פוש',
    push_notification_action_tooltip: 'לפריוריטי מובייל',
    assign_to_action: 'העברה לטיפול',
    allow_status_change_action: 'לאפשר מעבר סטטוס',
    save_changes_msg: 'שמרנו את השינויים.'
};

export const mapping = {
    2: 'path_open_rule_title',
    5: 'assign_to_action',
    6: 'allow_status_change_action',
    9: 'push_notification_action',
    10: 'push_notification_action_tooltip',
    11: 'status_open_rule_title',
    14: 'doc_remains_status',
    15: 'date_in_the',
    20: 'bpm_loader_title',
    21: 'add_path',
    22: 'set_rules',
    23: 'set_properties',
    24: 'set_color',
    25: 'delete_label',
    26: 'copy_label',
    27: 'paste_label',
    28: 'report_label',
    29: 'menu_set_rules',
    30: 'menu_set_props',
    31: 'rename_label',
    32: 'add_tooltip',
    33: 'permitted_status',
    34: 'new_status_dialog_title',
    35: 'status_name_label',
    36: 'name_input_placeholder',
    37: 'status_ename_label',
    38: 'bpm_screen_title',
    39: 'edit_status_dialog_title',
    40: 'doc_reaches_status',
    41: 'to_status_label',
    42: 'ago_label',
    43: 'help_title',
    44: 'BPM_title',
    45: 'close',
    46: 'BPM_help_text',
    47: 'status_dialog_rules_help',
    48: 'status_rule_help',
    49: 'warning_label',
    50: 'create_status_help_text',
    51: 'properties_help_text',
    52: 'ok_btn_text',
    53: 'permission_rule_upd_error',
    54: 'empty_state_bpm_rule_title',
    55: 'empty_state_bpm_rule_text',
    56: 'status_dialog_btn_cancel',
    57: 'save_label',
    58: 'hidden_statuses',
    59: 'number_input_label',
    60: 'hidden_statuses_label',
    61: 'statuses_dialog_title',
    62: 'statuses_list_dialog_btn_confirm',
    63: 'search_list_placeholder',
    64: 'allow_status_change_for',
    67: 'save_changes_msg',
    68: 'toolbar_active_label',
    69: 'toolbar_active_tooltip'
};

const fallbacks = {
    en,
    he
};

export function getServerTexts() {
    return getTexts(entity, mapping);
}

// init texts fallbacks according to the user's locale
initTexts(entity, fallbacks);

export const texts = localization[entity];
